import { getIdFromAction, take } from "../action.js";
import { parallel, safe } from "../fx/index.js";
import { StoreContext } from "./context.js";
export function* updateStore(updater) {
    const store = yield* StoreContext.expect();
    // had to cast the store since StoreContext has a generic store type
    const st = store;
    const ctx = yield* st.update(updater);
    return ctx;
}
export function* select(selectorFn, p) {
    const store = yield* StoreContext.expect();
    return selectorFn(store.getState(), p);
}
export function* waitForLoader(loaders, action) {
    const id = getIdFromAction(action);
    const selector = (s) => loaders.selectById(s, { id });
    // check for done state on init
    let loader = yield* select(selector);
    if (loader.isSuccess || loader.isError) {
        return loader;
    }
    while (true) {
        yield* take("*");
        loader = yield* select(selector);
        if (loader.isSuccess || loader.isError) {
            return loader;
        }
    }
}
export function* waitForLoaders(loaders, actions) {
    const group = yield* parallel(actions.map((action) => waitForLoader(loaders, action)));
    return yield* group;
}
export function createTracker(loader) {
    return (id) => {
        return function* (op) {
            yield* updateStore(loader.start({ id }));
            const result = yield* safe(op);
            if (result.ok) {
                yield* updateStore(loader.success({ id }));
            }
            else {
                yield* updateStore(loader.error({
                    id,
                    message: result.error.message,
                }));
            }
            return result;
        };
    };
}
